// extracted by mini-css-extract-plugin
export default {"AdditionalInfoP":"AdditionalInfoP_AdditionalInfoP__a96uF"};